import 'uni-pages';import 'uni-h5';
import Vue from 'vue'
import App from './App'
import uView from '@/uni_modules/uview-ui'
Vue.use(uView)
import sListForm from "@/components/basic/sListForm/s-list-form.vue";
Vue.component("s-list-form", sListForm);
import sEditForm from "@/components/basic/sEditForm/s-edit-form.vue";
Vue.component("s-edit-form", sEditForm);
// uView 时间轴组件1.0+版本才有 2.0+不在了则引用进来
import uTimeLine from "@/components/u-time-line/u-time-line.vue";
Vue.component("u-time-line", uTimeLine);
import uTimeLineItem from "@/components/u-time-line-item/u-time-line-item.vue";
Vue.component("u-time-line-item", uTimeLineItem);

// 引入uniwebView
import uniwebView from './utils/uni.webview.1.5.2.js'
import wechat from './utils/wechat.js'
Vue.prototype.$wechat = wechat;

Vue.prototype.hasPerm = function(value) {
  var btnList = uni.getStorageSync("btnUrl");
  return btnList && btnList.indexOf(value) != -1;
};

// 引入lodash
import _ from 'lodash'
Vue.prototype._ = _;

// import Aegis from 'aegis-web-sdk';

// const aegis = new Aegis({
// 	id: 'W7JbEfavOqrEe9b5vD', // 应用ID，即上报ID
// 	uin: 'xxx', // 用户唯一 ID（可选）
// 	reportApiSpeed: true, // 接口测速
// 	reportAssetSpeed: true, // 静态资源测速
// 	spa: true // spa 应用页面跳转的时候开启 pv 计算
// })


Vue.config.productionTip = false

//引入全局变量
import s from './config/sj.js'
window.s=s

// i18n部分的配置
// 引入语言包，注意路径
import zh_CN from './locales/zh.js';
import zh_TW from './locales/tw.js';
import en_US from './locales/en.js';

// 引入并使用vue-i18n
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

// 构造i18n对象
var i18n = new VueI18n({
	// 默认语言，这里的local属性，对应message中的cn、en属性
	locale: s.getVal(s.v.langCode) ? s.getVal(s.v.langCode) : s.v.lang,
	// 引入语言文件
	messages: {
		// 这里的属性名是任意的，您也可以把zh设置为cn等，只是后续切换语言时
		// 要标识这里的语言属性，如：this.$i18n.locale = zh|en|cn|xxx
		'zh_CN': zh_CN,
		'en_US': en_US,
		'zh_TW': zh_TW
	}
})

setTimeout(() => {
	uni.webView.getEnv((res) => {
		let result
		if (res.plus) {
			result = plus.storage.getItem('lang');
		} else {
			result = uni.getStorageSync('lang')
		}
		i18n.locale = result
	});
}, 100)


// 由于微信小程序的运行机制问题，需声明如下一行，H5和APP非必填
Vue.prototype._i18n = i18n

App.mpType = 'app'

const app = new Vue({
	i18n,
	...App
})
app.$mount()

















